import { mapGetters } from 'vuex';

import { isTenantPartner } from '@/services/advisoryPartner';

const DEFAULT_FONT_URL = '/fonts/RecklessNeue-Bold.otf';

export default {
    computed: {
        // Two profiles (services/advisoryPartner.js). Everything tenant-facing below —
        // copy, legal pages, feature switches, the font — reads `brand_profile`, the
        // host's partner, so the main app renders as Valur even for an advisor who
        // belongs to a firm. `advisory_partner_profile` is the workspace the advisor
        // pages act on; use it for workspace ids and names, never for branding.
        ...mapGetters('marketing', ['advisory_partner_profile', 'brand_profile']),
        isCalculatorEnabled() {
            return !this.isPartner || this.brand_profile?.is_calculator_enabled || false;
        },
        isFooterEnabled() {
            return this.brand_profile?.is_footer_enabled || false;
        },
        isCopyrightEnabled() {
            return this.brand_profile?.is_copyright_enabled || false;
        },
        isExternalLinkAvailable() {
            return !this.isPartner || this.brand_profile?.is_kb_available;
        },
        isOnboardingEnabled() {
            return !this.isPartner || this.brand_profile?.is_onboarding_enabled || true;
        },
        isOilGasQuestionnaireEnabled() {
            return this.brand_profile?.is_oil_gas_questionnaire_enabled || false;
        },
        isRiskAnalysisEnabled() {
            return this.brand_profile?.is_risk_analysis_enabled || false;
        },
        isPartner() {
            return isTenantPartner(this.brand_profile);
        },
        partnerName() {
            return this.brand_profile.name || 'Valur';
        },
        privacyPolicyContent() {
            return this.brand_profile?.privacy_policy;
        },
        termsOfServiceContent() {
            return this.brand_profile?.terms_of_service;
        },
        websiteDisclosureContent() {
            return this.brand_profile?.website_disclosure;
        },
    },
    methods: {
        // `params` (page/page_size/q/order_by/has_projects) opts into the paginated
        // response; called with no args (the default) the endpoint returns the full
        // client array, which the dashboard/workspace/team consumers rely on.
        async fetchClients(params = {}) {
            return await this.$store.dispatch('marketing/listAdvisorClients', {
                advisor_id: this.advisor_profile.uuid,
                advisory_partner_id: this.advisory_partner_profile.uuid,
                params,
            });
        },
    },
    watch: {
        brand_profile: {
            immediate: true,
            // The getter always returns an object, so the old `if (val)` branch never
            // fell through: a partner with no uploaded font produced `url("null")`,
            // which fails to load and leaves the face undefined. Key off font_url.
            handler(val) {
                const font = new FontFace('WhiteLabel', `url("${val?.font_url || DEFAULT_FONT_URL}")`);
                document.fonts.add(font);
            },
        },
    },
};
